<template>
  <transition name="fadein">
    <div
      class="totop"
      @click="totop()"
      @mouseenter="evtHeaderEnter()"
      :class="showt === true ? 'activetop' : ''"
      @mouseleave="evtHeaderLeave()"
      v-if="show"
    >
      <i class="el-icon-arrow-up"></i>
      <span>顶部</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: "totop",
  data() {
    return {
      show: false,
      showt: false
    };
  },
  methods: {
    evtHeaderEnter() {
      this.showt = true;
      clearTimeout(this.tids);
    },
    evtHeaderLeave() {
      let self = this;
      this.tids = setTimeout(function() {
        self.showt = false;
      }, 300);
    },
    totop: function() {
      $("html").animate({ scrollTop: 0 }, "slow");
    },
    scrollplay: function() {
      var ht = $(window).height();
      if (document.documentElement.scrollTop > ht) {
        this.show = true;
      } else {
        this.show = false;
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.scrollplay);
  }
};
</script>

<style lang="less" scoped>
.fadein-enter-active {
  transition: all 0.3s;
}
.fadein-leave-to {
  transition: all 0.3s;
}
// .fadein-transition {
//   transition: all .3s ease-in;
// 	height: 256px;
// 	opacity: 1;
// 	overflow: hidden;
// }
.fadein-enter,
.fadein-leave-to {
  height: 0;
  opacity: 0;
}
.totop {
  cursor: pointer;
  transition: all 0.2s;
  width: 40px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
  position: fixed;
  right: 0px;
  bottom: 60px;
  background: rgba(38, 38, 38, 0.3);
  padding: 5px;
  box-sizing: border-box;
  // display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;

  span {
    transition: all 0.2s;
    display: none;
    flex-wrap: nowrap;
    float: right;
    line-height: 30px;
    width: 0px;
    color: #fff;
    font-size: 12px;
    font-family: MicrosoftYaHei;
    color: #ffffff;
  }

  .el-icon-arrow-up {
    font-size: 18px;
    color: #fff;
    line-height: 30px;
    float: right;
    line-height: 30px;
    width: 30px;
    height: 30px;
    text-align: center;
    // margin-top: 10px;
  }
}
.totop:hover {
  width: 80px;
  padding: 5px 13px;
  background: #e23130;
  span {
    flex-wrap: nowrap;
    display: inline-block;
    width: auto;
    // padding-right: 17px;
  }
  .el-icon-arrow-up {
    color: #fff;
    float: right;
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/totop.vue